import { gql } from 'apollo-boost';

export const GET_DAILY_STATS = gql`
  query dailyStats($date: String) {
    dailyStats(date: $date) {
      messageCount
      commentCount
      newUserCount
      loginUserCount
    }
  }
`;